<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { type BackgroundIconType, BackgroundTheme } from '@/api/interfaces'
import { capitalize, getCSSVariable } from '@/helpers/utils'
import { useEditorStore } from '@/stores/Editor'

import LeavesIcon from '@/components/icons/backgrounds/LeavesIcon.vue'
import CirclesIcon from '@/components/icons/backgrounds/CirclesIcon.vue'

interface Props {
  iconType: BackgroundIconType
}

const props = defineProps<Props>()
const editorStore = useEditorStore()
const route = useRoute()

const icons = {
  LeavesIcon,
  CirclesIcon,
}

const icon = computed(() => {
  return icons[`${capitalize(props.iconType)}Icon` as keyof typeof icons]
})

const iconColor = computed(() => {
  if (editorStore.editor.background.theme === BackgroundTheme.DARK) {
    return getCSSVariable('lightest')
  }

  if (editorStore.editor.background.theme === BackgroundTheme.CUSTOM) {
    if (route.name === 'CommunityPage') {
      return getCSSVariable('ui-emerald-green')
    }

    return editorStore.editor.background.themeColor.background
  }

  return getCSSVariable('darkest')
})
</script>

<template>
  <component :is="icon" :color="iconColor" />
</template>

<style scoped lang="scss"></style>
